// extracted by mini-css-extract-plugin
export default {"rootContainer":"HeaderController_rootContainer__VmbmR","keywords":"HeaderController_keywords__vHKwg"};